import ShoppingCart from "@/components/Cart/ShoppingCart";
import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import { Container } from "@mui/material";

const CartPage = () => {
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 3, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <ShoppingCart />
    </>
  );
};

export default CartPage;
